import Style from './CarrosEletricosDisclaimerBanner.css';
import Container from '../../atoms/Container';
import React from 'react';

function CarrosEletricosDisclaimerBanner() {
  return (
    <>
      <section id="banner-disclaimer">
        <Container>
          <p>
            *Sujeito a análise de crédito e demais condições do produto no momento da contratação.
            Cupom válido para veiculos híbridos e elétricos 0km.
          </p>
        </Container>
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default CarrosEletricosDisclaimerBanner;
